export const siteLowLevelDesignMessages = {
  en: {
    pageTitle: 'Site Low Level Design',
    actionColumnTitle: 'Action',
    btnDownloadReport: 'Download',
  },
};
